import type { Address } from 'viem'
export const ETH_TOKEN_ADDRESS = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE'

export interface NetworkTokens {
  [key: number]: { [key: string]: Address }
}

export const PAYING_TOKENS: NetworkTokens = {
  137: {
    POL: ETH_TOKEN_ADDRESS,
    USDC: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
  },
  1: {
    ETH: ETH_TOKEN_ADDRESS,
    USDC: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  },
  42220: {
    CELO: ETH_TOKEN_ADDRESS,
    USDC: '0xef4229c8c3250c675f21bcefa42f58efbff6002a',
  },
  11155111: {
    ETH: ETH_TOKEN_ADDRESS,
    USDC: '0x14196f08a4fa0b66b7331bc40dd6bcd8a1deea9f',
  },
  //Polygon Amoy
  80002: {
    MATIC: '0x0c86A754A29714C4Fe9C6F1359fa7099eD174c0b',
    USDC: '0x14196f08a4fa0b66b7331bc40dd6bcd8a1deea9f', //crossmint
    //USDC: '0x0c86A754A29714C4Fe9C6F1359fa7099eD174c0b', //transak
    //USDC: '0x41E94Eb019C0762f9Bfcf9Fb1E58725BfB0e7582', //test
  },
  //Blast
  81457: {
    ETH: ETH_TOKEN_ADDRESS,
    // USDC: '0x8D89c5CaA76592e30e0410B9e68C0f235c62B312',
    USDB: '0x4300000000000000000000000000000000000003',
  },
  //Base
  8453: {
    ETH: ETH_TOKEN_ADDRESS,
    USDC: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
  },
  //Skale Calypso
  1564830818: {
    // SFUEL: ETH_TOKEN_ADDRESS,
    USDC: '0x7Cf76E740Cb23b99337b21F392F22c47Ad910c67',
  },
  974399131: {
    // SFUEL: ETH_TOKEN_ADDRESS,
    USDC: '0x2aebcdc4F9f9149a50422Fff86198Cb0939Ea165',
  },
}
